<template>
  <div class="box mx-12 my-4 px-6 py-5">
    <div class="mb-5 flex items-center justify-end sm:flex-row">
      <BaseDeleteButton
        v-if="$can('delete_content')"
        :tooltip="$t('button.delete_m', { var: $t('global.message_text') })"
        @click="$emit('deleteMessage', message_text.id)"
      />
    </div>
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-2 font-normal">
        {{ $t('enums.config.Languages.' + message_text.language) }}
      </div>

      <div class="col-span-1 font-normal">
        {{ message_text.type.toLowerCase() }}
      </div>
      <div class="col-span-6 pb-4">
        <div class="mb-3 text-base font-bold capitalize">
          {{ message_text.title }}
        </div>
        <div
          class="h-20 truncate pt-5 font-normal"
          v-html="message_text.text"
        ></div>
      </div>
      <div class="col-span-3 text-center">{{ getGroup }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleMessageTextComponent',
  props: {
    message_text: {
      type: Object,
      required: true
    },
    groups: {
      type: Object
    }
  },
  computed: {
    getGroup() {
      let group = this.groups.filter((g) => g.id === this.message_text.group)
      return Object.values(group)[0]['name']
    }
  },
  methods: {
    deleteMessageText() {
      this.$emit('deleteMessageText', this.message_text.id)
    }
  }
}
</script>
